export const RUNTIME_CONFIG_KEYS = [
  'OIDC_AUTHORITY',
  'OIDC_CLIENT_ID',
  'BACKEND_URL',
  'DATADOG_APPLICATION_ID',
  'DATADOG_CLIENT_TOKEN',
  'ENVIRONMENT',
  'HOST',
  'AMPLITUDE_API_KEY',
] as const

export type PublicEnvKey = (typeof RUNTIME_CONFIG_KEYS)[number]
export type RuntimeConfig = Record<PublicEnvKey, string>

let RUNTIME_CONFIG: RuntimeConfig | null = null

const parseConfig = (raw: unknown): RuntimeConfig => {
  if (typeof raw !== 'object' || raw === null) {
    throw new Error('config.json is not an object')
  }
  const obj = raw as Record<string, unknown>
  const out = {} as Record<PublicEnvKey, string>
  for (const k of RUNTIME_CONFIG_KEYS) {
    const v = obj[k]
    if (typeof v !== 'string' || v.length === 0) {
      throw new Error(`Invalid or missing config key: ${k}`)
    }
    out[k] = v
  }
  return out as RuntimeConfig
}

export const loadConfig = async (): Promise<RuntimeConfig> => {
  const res = await fetch('/config.json', { cache: 'no-store' })
  if (!res.ok) throw new Error('Cannot load config.json')

  const raw = (await res.json()) as unknown
  const cfg = parseConfig(raw)
  RUNTIME_CONFIG = cfg
  return cfg
}

export const getRequiredPublicEnv = (name: PublicEnvKey): string => {
  if (!RUNTIME_CONFIG) throw new Error('Config not loaded yet for name: ' + name)
  const value = RUNTIME_CONFIG[name]
  if (value.length === 0) throw new Error(`Missing required environment variable: ${name}`)
  return value
}
